// <uint3 numCards><uint7 bonus><uint7 value><uint7 bonus><uint7 value><uint7 bonus><uint7 value><uint7 bonus><uint7 value>
export function fromBigIntToCards(type, gear) {
    const cards = [];
    const numCards = gear >> 98n;
    for (let i = 0n; i < numCards; i++) {
        const offset = 91n - 7n * i * 2n;
        const bonus = Number((gear >> offset) & 127n);
        const value = Number((gear >> (offset - 7n)) & 127n);
        cards.push(type == 'attack'
            ? {
                type,
                atk: bonus,
                dmg: value,
            }
            : {
                type,
                def: bonus,
                armor: value,
            });
    }
    return cards;
}
//# sourceMappingURL=cards.js.map